"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGift = void 0;

var _react = require("react");

var _reactRedux = require("react-redux");

var R = _interopRequireWildcard(require("ramda"));

var _services = require("@alycecom/services");

var _query = require("@reduxjs/toolkit/query");

var _gift = require("../store/gift/gift.selector");

var _gift2 = require("../store/gift/gift.actions");

var _GiftResearchFlow = require("../../types/GiftResearchFlow.types");

var _useTrackGiftingFlow = require("./useTrackGiftingFlow");

/**
 * Properties will exists only if gift has been created.
 */
var useGift = function useGift() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var id = (0, _reactRedux.useSelector)(_gift.getGiftId);
  var gift = (0, _reactRedux.useSelector)(_gift.getGift);
  var campaignId = (0, _reactRedux.useSelector)(_gift.getGiftCampaignId);

  var _useGetCampaignByIdQu = (0, _services.useGetCampaignByIdQuery)(campaignId || _query.skipToken),
      campaign = _useGetCampaignByIdQu.data,
      isSuccess = _useGetCampaignByIdQu.isSuccess;

  var isLoading = (0, _reactRedux.useSelector)(_gift.getGiftIsLoading);
  var isGiftContactOptedOut = (0, _reactRedux.useSelector)(_gift.getIsGiftContactOptedOut);
  var isGiftContactSyncIdle = (0, _reactRedux.useSelector)(_gift.getIsGiftContactSyncIdle);
  var isGiftContactSyncLoading = (0, _reactRedux.useSelector)(_gift.getIsGiftContactSyncLoading);
  var isGiftContactSyncCompleted = (0, _reactRedux.useSelector)(_gift.getIsGiftContactSyncCompleted);
  var recipientId = (0, _reactRedux.useSelector)(_gift.getGiftRecipientId);
  var recipient = (0, _reactRedux.useSelector)(_gift.getGiftRecipient);
  var productId = (0, _reactRedux.useSelector)(_gift.getGiftProductId);
  var product = (0, _reactRedux.useSelector)(_gift.getGiftProduct);
  var proposedProducts = (0, _reactRedux.useSelector)(_gift.getProposedProducts);
  var researchType = (0, _reactRedux.useSelector)(_gift.getGiftResearchType);
  var isResearchProcessing = (0, _reactRedux.useSelector)(_gift.getIsResearchProcessing);
  var researchFlow = R.prop('researchType', campaign || {});
  var isMarketplaceAllowed = !(isResearchProcessing && researchFlow === _GiftResearchFlow.GiftResearchFlowType.requireResearch);
  var isFullResearchAllowed = isSuccess && (researchFlow === _GiftResearchFlow.GiftResearchFlowType.requireResearch || researchFlow === _GiftResearchFlow.GiftResearchFlowType.instantGiftOrResearch);
  var trackFullResearch = (0, _useTrackGiftingFlow.useTrackGiftingFlowFullResearchRequested)();
  return {
    id,
    gift,
    isLoading,
    isGiftContactOptedOut,
    isGiftContactSyncIdle,
    isGiftContactSyncLoading,
    isGiftContactSyncCompleted,
    researchType,
    campaignId,
    campaign,
    recipientId,
    recipient,
    productId,
    product,
    proposedProducts,
    isResearchProcessing,
    isMarketplaceAllowed,
    isFullResearchAllowed,

    /**
     * Create gift with passed campaign id and recipient id.
     * Can be called without arguments if hook receive campaign and recipient ids from arguments.
     *
     * @param {number} campaignId - Campaign by that gift will be created.
     * @param {string} sfContactId - Salesforce contact id.
     * @param {string} sfLeadId - Salesforce lead id.
     * @param {number} recipientId - Recipient for that gift will be created.
     */
    create: (0, _react.useCallback)(function (_ref) {
      var cid = _ref.campaignId,
          rid = _ref.recipientId,
          sfContactId = _ref.sfContactId,
          sfLeadId = _ref.sfLeadId;
      return dispatch((0, _gift2.giftCreateRequest)({
        campaignId: cid,
        contactId: rid,
        sfContactId,
        sfLeadId
      }));
    }, [dispatch]),

    /**
     * Create callback that create gift with selected product.
     * You may pass nothing to arguments and required d
     *
     * @namespace
     * @param {Object} [details={}]
     * @param {number} [details.campaignId=]  - Id of campaign by that gift will be created.
     *                                          By default will took local campaign id.
     * @param {number} [details.recipientId=] - Recipient id for that gift will be created.
     *                                          By default will took local recipient id.
     * @param {{
     *  id: number,
     *  denomination: number
     * }} [product=]                          - Product which will be assign to the gift.
     *                                          By default will take chosen product in marketplace.
     * @param {{ id: number }} [currency=]    - Currency id of product. By default will took gift currency from marketplace.
     */
    createWithProduct: (0, _react.useCallback)(function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          cid = _ref2.campaignId,
          rid = _ref2.recipientId,
          pid = _ref2.productId,
          denomination = _ref2.denomination,
          currencyId = _ref2.currencyId;

      dispatch((0, _gift2.giftCreateRequest)({
        campaignId: cid,
        contactId: rid,
        product: {
          id: pid,
          denomination,
          denomination_currency_id: currencyId
        }
      }));
    }, [dispatch]),

    /**
     * Push gift to agents research.
     */
    toFullResearch: (0, _react.useCallback)(function () {
      dispatch((0, _gift2.giftSetFullResearch)(id));
      trackFullResearch();
    }, [dispatch, id, trackFullResearch]),
    chooseProduct: (0, _react.useCallback)(function (pid) {
      return dispatch((0, _gift2.selectProduct)(id, pid));
    }, [dispatch, id])
  };
};

exports.useGift = useGift;